export const QUOTE_APPS_PANEL_STATES = {
  QUOTE_FILES: 'QUOTE_FILES',
  REQS_REVIEW: 'REQS_REVIEW',
  CHAT: 'CHAT',
} as const;

export type QuoteAppsPanelState =
  (typeof QUOTE_APPS_PANEL_STATES)[keyof typeof QUOTE_APPS_PANEL_STATES];
